import Piii from 'piii'
import piiiFilters from 'piii-filters'

// evite recriar em cada validação
const piii = new Piii({
  filters: [
    // carrega todos os filtros do pacote (PT-BR)
    ...Object.values(piiiFilters)
  ],
  // mapeia leet comum para pegar disfarces
  aliases: {
    a: ['@', '4'],
    e: ['3', '&'],
    i: ['1', '!'],
    o: ['0'],
    s: ['$']
  },
  // considera repetições (porrrrrra)
  repeated: true
})

export const hasProfanity = (text: string) => piii.has(text)
export const filterProfanity = (text: string) => piii.filter(text)
